<template>
  <div id="app" ref="three" />
</template>

<script>
// 引入需要的模块
import * as THREE from "three"; // Three.js
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"; // 相机控制
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"; // GLTF 模型加载器
import TWEEN from "three-tween"; // 动画库

// 定义数组
const bufArrays = [];
// 当前加载到的模型编号
let current = 0;

export default {
  mounted() {
    this._initBase(); // 在 Vue 实例挂载后初始化场景
  },
  beforeDestroy() {
    if (this._rafId) cancelAnimationFrame(this._rafId);
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    _initBase() {
      // 创建场景
      this.scene = new THREE.Scene();
      // 设置背景
      this.scene.background = this.backgroundTexture();
      // 创建相机
      this.camera = new THREE.PerspectiveCamera(
        45,
        window.innerWidth / window.innerHeight,
        0.1,
        80
      );
      // 设置相机位置
      this.camera.position.set(0, 0, 6);
      // 创建渲染器
      try {
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
      } catch (e) {
        console.warn('WebGL not available, 3D background disabled');
        return;
      }
      // 设置像素比例
      this.renderer.setPixelRatio(window.devicePixelRatio);
      // 设置渲染器大小
      this.renderer.setSize(window.innerWidth, window.innerHeight);

      // 创建加载管理器
      const manager = new THREE.LoadingManager();
      // 开始加载时的回调
      manager.onStart = (url, itemsLoaded, itemsTotal) => {
        console.log("onStart");
      };
      // 加载完成时的回调
      manager.onLoad = () => {
        console.log("onLoad");
        this.transition();
      };
      // 加载错误时的回调
      manager.onError = (url) => {
        console.log(url);
      };

      // 创建 GLTF 加载器
      const gltfLoader = new GLTFLoader(manager);

      // 加载第一个模型
      gltfLoader.load(require('@/assets/mods/box.glb'), (gltf) => {
        gltf.scene.traverse((child) => {
          if (child.isMesh) {
            child.geometry.translate(0, 0.5, 0);
            const { array } = child.geometry.attributes.position;
            bufArrays.push(array);
          }
        });
      });

      // 加载第二个模型
      gltfLoader.load(require('@/assets/mods/box1.glb'), (gltf) => {
        gltf.scene.traverse((child) => {
          if (child.isMesh) {
            child.geometry.scale(0.5, 0.5, 0.5);
            const { array } = child.geometry.attributes.position;
            bufArrays.push(array);
          }
        });
      });

      // 加载第三个模型
      gltfLoader.load(require('@/assets/mods/box2.glb'), (gltf) => {
        gltf.scene.traverse((child) => {
          if (child.isMesh) {
            child.geometry.translate(1, 0, 0);
            const { array } = child.geometry.attributes.position;
            bufArrays.push(array);
          }
        });
      });

      console.log(bufArrays);
      // 创建点云几何体
      this.geometry = new THREE.BufferGeometry();
      // 存储动画
      this.geometry.tween = [];
      const vertices = [];
      // 随机生成点的位置
      for (let i = 0; i < 26016; i++) {
        const position = THREE.MathUtils.randFloat(-4, 4);
        // 保存动画效
        this.geometry.tween.push(
          new TWEEN.Tween({ position }).easing(TWEEN.Easing.Exponential.In)
        );
        vertices.push(position);
      }
      this.geometry.setAttribute(
        "position",
        new THREE.BufferAttribute(new Float32Array(vertices), 3)
      );

      this.points = new THREE.Points(
        this.geometry,
        new THREE.PointsMaterial({
          size: 0.03,

          map: new THREE.TextureLoader().load(require('@/assets/mods/white-dot.png')),
          alphaTest: 0.1,
          opacity: 0.5,
          transparent: true,
          depthTest: true,
        })
      );
      this.scene.add(this.points);
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.update();
      this.$refs.three.appendChild(this.renderer.domElement);
      window.addEventListener("resize", this.onWindowResize, false);
      this.render();
    },

    transition() {
      const self = this;
      for (let i = 0, j = 0; i < 26016; i++, j++) {
        const item = this.geometry.tween[i];
        if (j >= bufArrays[current].length) {
          j = 0;
        }
        item
          .to(
            { position: bufArrays[current][j] },
            THREE.MathUtils.randFloat(100, 4000)
          )
          .onUpdate(function () {
            self.geometry.attributes.position.array[i] = this.position;
            self.geometry.attributes.position.needsUpdate = true;
          })
          .start();
      }
      setTimeout(() => {
        this.transition();
      }, 5000);
      current = (current + 1) % 3;
    },
    // 控制模型旋转
    render() {
      this.points.rotation.x += 0;
      this.points.rotation.y += 0.001;
      this.points.rotation.z += 0;
      TWEEN.update();
      this.renderer.render(this.scene, this.camera);
      this._rafId = requestAnimationFrame(this.render);
    },
    onWindowResize() {
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
    },
    backgroundTexture() {
      const canvas = document.createElement("canvas");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      const ctx = canvas.getContext("2d");
      const gradient = ctx.createLinearGradient(0, 0, window.innerWidth, 0);
      // gradient.addColorStop(0, '#4e22b7')
      // gradient.addColorStop(1, '#3292ff')
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const canvasTexture = new THREE.CanvasTexture(canvas);
      return canvasTexture;
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
  background: rgb(0, 0, 0);
}
</style>
